module.exports = __webpack_public_path__ + "static/media/1.c0b110ce.jpg";